import { render } from "./FloatingAlert.vue?vue&type=template&id=3e970872&scoped=true"
import script from "./FloatingAlert.vue?vue&type=script&lang=js"
export * from "./FloatingAlert.vue?vue&type=script&lang=js"

import "./FloatingAlert.vue?vue&type=style&index=0&id=3e970872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e970872"]])

export default __exports__